/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { DsMatchSummaryStatus, RejectionLossCode } from "../enums";
export const oppCandMLRecSchema: z.AnyZodObject = z.object({
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  candidateOpportunityId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  dsMatchSummary: 
    z.object({
      data: 
        z.object({
          clientSubmissionDraft: z.string().nullish(),
          concerns: z.array(z.string()).nullish(),
          evidence: z.array(z.string()).nullish(),
          fitDecision: z.string().nullish(),
          topMatchPoints: z.array(z.string()).nullish(),
        })
      .nullish(),
      error: 
        z.object({
          message: z.string().nullish(),
          statusCode: z.number().int().nullish(),
        })
      .nullish(),
      failedAt: z.string().datetime().nullish(),
      receivedAt: z.string().datetime().nullish(),
      requestedAt: z.string().datetime().nullish(),
      status: z.nativeEnum(DsMatchSummaryStatus).nullish(),
    })
  .nullish(),
  id: z.string().uuid(),
  mlLossCode: z.nativeEnum(RejectionLossCode).nullish(),
  opportunityId: z.string().uuid().nullish(),
  updatedAt: z.string().datetime().nullish(),
  updatedBy: z.string().uuid().nullish(),
});

export type OppCandMLRec = z.infer<typeof oppCandMLRecSchema>;
